import { MetaResponse } from '@genial/services/dist/models';
import { atom } from 'recoil';

import { PublicOfferEntityNormalized } from '../types';

export const publicOffersLoadedState = atom({
  key: 'publicOffersLoadedState',
  default: { data: [] as PublicOfferEntityNormalized[], meta: {} as MetaResponse, loaded: false },
});

export const publicOffersProductsLoadedState = atom({
  key: 'publicOffersProductsLoadedState',
  default: { data: [] as PublicOfferEntityNormalized[], meta: {} as MetaResponse, loaded: false },
});
